import { render, staticRenderFns } from "./ProjectIssuesList.vue?vue&type=template&id=38078080&scoped=true&"
import script from "./ProjectIssuesList.vue?vue&type=script&lang=ts&"
export * from "./ProjectIssuesList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectIssuesList.vue?vue&type=style&index=0&id=38078080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38078080",
  null
  
)

export default component.exports